import { createScenarioStub } from "../scenarioFlow/ScenarioFlowStub";
import { ROUTES } from "../../utils/constants";

export default createScenarioStub({
	scenarioNum: 3,
	kind: "context",
	label: "Contexto 2 (plantilla)",
	nextRoute: ROUTES.SCENARIO3_FIN,
});
